var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 63.244,
    height: 58.66,
    viewBox: "0 0 63.244 58.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1ad56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71572b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning_small",
    "data-name": "warning small",
    transform: "translate(-3.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M39.233,48.472v-6.7a1.125,1.125,0,0,0-.335-.828,1.084,1.084,0,0,0-.793-.335H31.336a1.084,1.084,0,0,0-.793.335,1.125,1.125,0,0,0-.335.828v6.7a1.125,1.125,0,0,0,.335.828,1.084,1.084,0,0,0,.793.335H38.1A1.084,1.084,0,0,0,38.9,49.3,1.125,1.125,0,0,0,39.233,48.472Zm-.07-13.184L39.8,19.107a.776.776,0,0,0-.353-.67,1.362,1.362,0,0,0-.846-.388H30.843a1.362,1.362,0,0,0-.846.388.844.844,0,0,0-.353.74l.6,16.11a.677.677,0,0,0,.353.582,1.518,1.518,0,0,0,.846.229h6.522a1.433,1.433,0,0,0,.828-.229A.784.784,0,0,0,39.162,35.288ZM38.669,2.362,65.743,52a4.205,4.205,0,0,1-.071,4.442,4.509,4.509,0,0,1-3.878,2.221H7.647a4.509,4.509,0,0,1-3.878-2.221A4.205,4.205,0,0,1,3.7,52L30.772,2.362A4.5,4.5,0,0,1,32.429.635a4.455,4.455,0,0,1,4.583,0A4.5,4.5,0,0,1,38.669,2.362Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.d030529cbfa75dc7747ba09a55688ff8.svg";
export { ForwardRef as ReactComponent };